export default [
  {
    path: '/auto-invoice',
    name: 'AutoInvoice',
    component: () => import(/* webpackChunkName: "customer-verify-autoinvoice-token" */ '@/views/Customer/VerifyAutoInvoiceToken.vue'),
  },
  {
    path: '/customer/auto-invoice/:id([0-9]+)',
    name: 'AutoInvoiceDetail',
    component: () => import(/* webpackChunkName: "customer-autoinvoice" */ '@/views/Customer/AutoInvoice.vue'),
  },
  {
    path: '/customer/auto-invoice/:id([0-9]+)/stamped',
    name: 'AutoInvoiceStamped',
    component: () => import(/* webpackChunkName: "customer-autoinvoice-stamped" */ '@/views/Customer/AutoInvoiceStamped.vue'),
  },
  {
    path: '/status-account',
    name: 'StatusAccount',
    component: () => import(/* webpackChunkName: "customer-verify-status-account-token" */ '@/views/Customer/VerifyStatusAccountToken'),
  },
  {
    path: '/status-account/detail',
    name: 'StatusAccountDetail',
    component: () => import(/* webpackChunkName: "customer-status-account-detail" */ '@/views/Customer/StatusAccountDetail.vue'),
  },
];
